import { ServiceData } from '@/types';

import articles from './COOKING_ARTICLES_BG.json';
import recipes from './COOKING_RECIPES_BG.json';
import videos from './COOKING_VIDEOS_BG.json';

export const COOKING_DATA_BG: ServiceData = {
  articles,
  recipes,
  videos,
};
